import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-20 text-center md:px-8">
      <span className="font-heading text-7xl font-black text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        抱歉，你访问的页面不存在或已被移除。
      </p>
      <p className="mt-1 font-label text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-secondary-100 cursor-pointer"
        >
          浏览电影分类
        </Link>
      </div>
    </div>
  );
}